
// 二期巡检
import request from '../utils/request'
const { swPatrol } = window.globalConfig;
export default class InspectApi {
  /**
   * 查询巡检模版 分页 POST /patrol/template/listByPage
   * @param params
   * @returns {*|Promise<*>}
   */
  static query = (params) => {
    return request.post(`/${swPatrol}/patrol/template/listByPage`, params)
  }
  /**
   * 创建巡检模版
   * @param params
   * @returns {*|Promise<*>}
   */
  static add = (params) => {
    return request.post(`/${swPatrol}/patrol/template/add`, params)
  }
  /**
 * 状态启用
 * @param params
 * @returns {*|Promise<*>}
 */
  static enable = (params) => {
    return request.post(`/${swPatrol}/patrol/template/enable?id=${params.id}`)
  }
  /**
 * 状态禁用
 * @param params
 * @returns {*|Promise<*>}
 */
  static disenable = (params) => {
    return request.post(`/${swPatrol}/patrol/template/disenable?id=${params.id}`)
  }
  /**
   * 查询模版详情
   * @param params
   * @returns {*|Promise<*>}
   */
  static getInfo = (id) => {
    return request.appid(`/${swPatrol}/patrol/template/getInfo?templateId=${id}`)
  }
  /**
   * 修改巡检模版
   * @param params
   * @returns {*|Promise<*>}
   */
  static update = (params) => {
    return request.post(`/${swPatrol}/patrol/template/updateInfo`, params)
  }
  // POST /patrol/template / batchImportTemplate
  /**
   * 导入模版
   * @param params
   * @returns {*|Promise<*>}
   */
  static batchImportTemplate = (params, config) => {
    return request.post(`/${swPatrol}/patrol/template/batchImportTemplate`, params, config)
  }
  /*********************** 巡检标准 b **************************/
  /**
   * 巡检标准新增
   * @param params
   * @returns {*|Promise<*>}
   */
  static standAdd = (params) => {
    return request.post(`/${swPatrol}/patrol/standard/add`, params)
  }
  /**
   * 巡检标准状态启用
   * @param params
   * @returns {*|Promise<*>}
   */
  static standEnable = (params) => {
    return request.post(`/${swPatrol}/patrol/standard/enable?id=${params.id}`)
  }
  /**
   * 巡检标准状态禁用
   * @param params
   * @returns {*|Promise<*>}
   */
  static standDisenable = (params) => {
    return request.post(`/${swPatrol}/patrol/standard/disenable?id=${params.id}`)
  }
  /**
   * 巡检标准获取详情
   * @param params
   * @returns {*|Promise<*>}
   */
  static standGetInfo = (params) => {
    return request.appid(`/${swPatrol}/patrol/standard/getInfo`, params)
  }
  /**
   * 巡检标准-查询列表
   * @param params
   * @returns {*|Promise<*>}
   */
  static standQuery = (params) => {
    return request.post(`/${swPatrol}/patrol/standard/listByPage`, params)
  }
  /**
   * 巡检标准修改信息
   * @param params
   * @returns {*|Promise<*>}
   */
  static standUpdate = (params) => {
    return request.post(`/${swPatrol}/patrol/standard/updateInfo`, params)
  }
  /*********************** 巡检计划 e **************************/

  /*********************** 巡检项 b **************************/

  static getPatrolItems = (id, type) => {
    return request.appid(`/${swPatrol}/patrol/patrolitem/getPatrolItems?stationId=${id}&type=${type}`)
  }
  static selectPatrolItemByStation = (id) => {
    return request.appid(`/${swPatrol}/patrol/patrolitem/selectPatrolItemByStation?stationId=${id}`)
  }
  static selectPatrolItemsByParams = (params) => {
    return request.post(`/${swPatrol}/patrol/patrolitem/selectPatrolItemsByParams`, params)
  }
  /*********************** 巡检项 e **************************/

  /*********************** 巡检任务 b **************************/
  // 巡检任务列表
  static taskQuery = (params) => {
    return request.post(`/${swPatrol}/patrol/patroltask/pageList`, params)
  }
  // 巡检任务详情
  static getPatrolTaskInfo = (params) => {
    return request.post(`/${swPatrol}/patrol/patroltask/getPatrolTaskInfo`, params)
  }
  /*********************** 巡检任务 e **************************/


  /*********************** 缺陷 b **************************/
  // 列表
  static defectQuery = (params) => {
    return request.post(`/${swPatrol}/patrol/patroldefect/pageList`, params)
  }
  // 关闭缺陷
  static closeDefectOrder = (id) => {
    return request.appid(`/${swPatrol}/patrol/patroldefect/closeDefectOrder?id=${id}`)
  }
  // 缺陷转工单
  static turnToWorkOrder = (params) => {
    return request.post(`/${swPatrol}/patrol/patroldefect/turnToWorkOrder`, params)
  }
  /*********************** 缺陷 e **************************/


  /*********************** 工单 b **************************/
  // 工单列表
  static orderQuery = (params) => {
    return request.post(`/${swPatrol}/patrol/patrolWorkOrder/pageList`, params)
  }
  static orderStatus = (params) => {
    return request.post(`/${swPatrol}/patrol/patrolWorkOrder/updateStatus`, params)
  }
  /*********************** 工单 e **************************/
}
